// extracted by mini-css-extract-plugin
module.exports = {"reviews":"mySwiper_reviews__gC_HD","mySwiper":"mySwiper_mySwiper__Me3cf","mySwiperSlide":"mySwiper_mySwiperSlide__6NCHs","name":"mySwiper_name__75OND"};